module.exports = __webpack_public_path__ + "static/media/catalouge-39.85c817e9.jpg";